// extracted by mini-css-extract-plugin
export default {"page":"J1-z","cartModal":"K1-z","checkout":"L1-z","placeholder":"M1-z","account":"N1-z"};